import http from '../http'
import { Res } from '../type'
import { IPostScore } from '@/api/Models/CommentCreate'
import { LikeSendParams } from '../Models/LikeSend'
import { LikeCancelParams } from '../Models/LikeCancel'

// 去评分
export const postScore = (data: IPostScore): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/score/create',
    method: 'post',
    data,
    loadingShow: data.loading
  })
}

// 点赞-点赞动作
export const postLikeSend = (data: LikeSendParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/like/likeOption',
    method: 'post',
    data,
    loadingShow: data.loadingShow
  })
}

// 点赞-取消点赞
export const postLikeCancel = (data: LikeCancelParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/like/cancelLike',
    method: 'post',
    data,
    loadingShow: data.loadingShow
  })
}
